module.exports = __webpack_public_path__ + "static/1249730776.ed8c9286.jpg";